import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'unique',
    standalone: false
})
export class UniquePipe implements PipeTransform {
	transform(collection, keyname) {
		var output = [];
		if (collection && collection.length > 0) {
			var keys = [];
			collection.forEach((item) => {
				var key = item[keyname];
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					output.push(item);
				}
			});
		}
		return output;
	}
}